import { useState, useEffect, useRef } from 'react'

interface UseDebounceOptions {
    ignoreInitialUpdate?: boolean
    maxSuppressedMs?: number
}

function useDebounce<T>(value: T, delay: number, options?: UseDebounceOptions) {
    // State and setters for debounced value
    const [debouncedValue, set_debouncedValue] = useState(value)
    const firstUpdate = useRef(options?.ignoreInitialUpdate || false)

    const lastSetTimeRef = useRef<Date>(new Date())

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false
            return
        }

        // Set debouncedValue to value (passed in) after the specified delay
        const handler = setTimeout(() => {
            lastSetTimeRef.current = new Date()
            set_debouncedValue(value)
        }, delay)

        return () => {
            if (options?.maxSuppressedMs) {
                if (+new Date() - +lastSetTimeRef.current > options?.maxSuppressedMs) {
                    lastSetTimeRef.current = new Date()
                    set_debouncedValue(value)
                }
            }

            clearTimeout(handler)
        }
    }, [delay, value])

    return debouncedValue
}

export default useDebounce
